  <body class='login'>


    <mat-card class="card">
        <img src="../../../assets/logo-1.jpg" alt="Tumsa Logo">
        <mat-card-content>

            <form [formGroup]="options" (ngSubmit)="login()">

                <mat-form-field appearance="fill" [hideRequiredMarker]="hideRequiredControl.value"
                    [floatLabel]="floatLabelControl.value">
                    <input matInput formControlName="username" placeholder="Usuario" required
                        oninput="this.value = this.value.toLowerCase()">
                </mat-form-field>
                <mat-error *ngIf="options.get('username').errors && options.get('username').touched">Por favor introduzca un
                    nombre de usuario válido</mat-error>

                <mat-form-field appearance="fill" [hideRequiredMarker]="hideRequiredControl.value"
                    [floatLabel]="floatLabelControl.value">
                    <input matInput [type]="'password'" formControlName="password" placeholder="Contraseña" required>
                </mat-form-field>
                <mat-error *ngIf="options.get('password').errors && options.get('password').touched">Por favor
                    introduzca una contraseña válida válido</mat-error>

                <button mat-stroked-button type="submit"  [disabled]="!options.valid">Enviar</button>

                <button mat-stroked-button (click)="candidato()">Soy Candidato</button>

            </form>


        </mat-card-content>
    </mat-card>



</body>